import { autoCompleteStyleOverride } from "./Autocomplete";
import { backdropStyleOverride } from "./Backdrop";
import { buttonStyleOverride } from "./Button";
import { cardStyleOverride } from "./Card";
import { iconButtonStyleOverride } from "./IconButton";
import { inputStyleOverride } from "./Input";
import { listsStyleOverride } from "./Lists";
import { paperStyleOverride } from "./Paper";
import { tooltipStyleOverride } from "./Tooltip";
import { typographyStyleOverride } from "./Typography";

export const overrideComponentsStyle = {
    ...autoCompleteStyleOverride,
    ...backdropStyleOverride,
    ...buttonStyleOverride,
    ...cardStyleOverride,
    ...iconButtonStyleOverride,
    ...inputStyleOverride,
    ...listsStyleOverride,
    ...paperStyleOverride,
    ...tooltipStyleOverride,
    ...typographyStyleOverride,
};
